export default "__VITE_ASSET__DcVoKKaM__"